/*
 *   File : video-card.js
 *   Author : https://evoqins.com
 *   Description : Video cards component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react'

import Icon from '../Icon/icon';
import styles from "../../Style/Component/card.module.scss";

function VideoCard({ data, handleClickVideo, type }) {

    // type 2 : onboarding style (Poppins text, 10px title gap, 30px arrow)
    if (type === 2) {
        return (
            <div className={`${styles.e_video_card} d-flex flex-column gap-0 e-bg-cultured e-border-radius-16 cursor-pointer card-hover h-100`}
                onClick={handleClickVideo}>
                <div className={`${styles.e_video_card_thumbnail} video-wrapper position-relative margin-10px-bottom`}>
                    <img
                        src={data.thumbnail}
                        className="d-block w-100 h-100 object-fit-cover"
                        alt="video thumbnail"
                        draggable="false"
                    />
                    <span className="video-ply-btn p-1">
                        <Icon icon="video-play-btn" size={16} className="" />
                        <span className="e-text-dark-jet e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px">
                            {data.duration}
                        </span>
                    </span>
                </div>

                <h5 className="e-text-black e-alt-font-poppins e-font-weight-500 e-font-14 e-line-height-100 margin-10px-bottom">
                    {data.title}
                </h5>

                <div className={`${styles.e_video_card_author_v2} d-flex align-items-center justify-content-between gap-2`}>
                    <div className="min-w-0">
                        <p className="e-text-dark-jet e-alt-font-poppins e-font-weight-500 e-font-12 line-height-24px letter-spacing-0-12px mb-0 text-truncate">
                            {data.speaker_name}
                        </p>
                        <p className="e-text-black-64 e-alt-font-poppins e-font-weight-500 e-font-12 line-height-22-93px letter-spacing-0-12px mb-0 text-truncate">
                            {data.designation}
                        </p>
                    </div>
                    <Icon icon="right-black-icon"
                        size={30}
                        className={`${styles.e_video_card_arrow} flex-shrink-0`} />
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.e_video_card} d-flex flex-column e-bg-cultured e-border-radius-16 cursor-pointer card-hover h-100`}
            onClick={handleClickVideo}>
            <div className={`${styles.e_video_card_thumbnail} video-wrapper position-relative`}>
                <img
                    src={data.thumbnail}
                    className={`${styles.e_video_card_img} w-100`}
                    alt="video thumbnail"
                    draggable="false"
                />
                <span className="video-ply-btn p-1">
                    <Icon icon="video-play-btn" size={16} className="" />
                    <span className="e-text-dark-jet e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px">
                        {data.duration}
                    </span>
                </span>
            </div>

            <h5 className={`${styles.e_video_card_title} e-text-dark-jet e-font-12-res e-font-16 e-alt-font-poppins e-font-weight-500 mb-0`}>
                {data.title}
            </h5>

            <div className={`${styles.e_video_card_author} d-flex align-items-center justify-content-between gap-2`}>
                <div className="min-w-0">
                    <p className={`${styles.e_video_card_speaker} e-text-dark-jet e-font-12 e-alt-font-poppins e-font-weight-500 mb-0 text-truncate`}>
                        {data.speaker_name}
                    </p>
                    <p className={`${styles.e_video_card_designation} e-text-dark-jet e-primary-font-inter e-font-weight-400 mb-0 text-truncate`}>
                        {data.designation}
                    </p>
                </div>
                <Icon icon="right-black-icon"
                    size={16}
                    className={`${styles.e_video_card_arrow} flex-shrink-0`} />
            </div>
        </div>
    );

}

VideoCard.defaultProps = {
    type: 1
};

export default VideoCard
